import { ChildData } from 'react-router-navigation-prompt'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@carsys/ui'

export const BaseNavigationDialogContent = ({ isActive, onCancel, onConfirm }: ChildData) => {
  const { t } = useTranslation()

  return (
    <Dialog open={isActive}>
      <DialogTitle>{t('Form.NavigationConfirmation.Title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('Form.NavigationConfirmation.Content')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='primary' onClick={onCancel}>
          {t('Form.NavigationConfirmation.Cancel')}
        </Button>
        <Button color='primary' onClick={onConfirm}>
          {t('Form.NavigationConfirmation.Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
